import Vue from "vue";
import store from '@/store/index'
import SDK from "@yxim/nim-web-sdk";
import storage from '@/service/storage';
import { getStorage, setStorage, removeStorage } from '@/service/auth.js';
import { PostData } from '@/api/fetchdata';

let access_token = getStorage('token') ? getStorage('token') : '';
let nim = null;
let conversationList = [];
// 全局的会话管理器
const sessionManager = {
    sessions: {}, // 存储会话信息，包括定时器ID和最后消息时间
    timeout: 65000, // 超时时间，60秒
};

function initNim() {
    // let accid = getStorage('accid');
    // if (accid && access_token) {
    //     PostData({
    //         microservices: "lmall/admins/im/refreshToken",
    //         accid, // 云信控制台获取或服务端注册的用户账号 accid
    //     })
    //         .then((res) => {
    //             if (res.data.ret === 200) {
    //                 // 引入SDK类的引用以后，获取SDK对象实例
    //                 nim = SDK.NIM.getInstance({
    //                     debug: false, // 是否开启日志，将其打印到console。集成开发阶段建议打开。
    //                     appKey: "c74a068c770e31fba93e6291ef75b559", // 云信控制台获取的 App Key
    //                     account: res.data.data.accid,
    //                     token: res.data.data.token,
    //                     db: true, //若不要开启数据库请设置false。SDK默认为true。
    //                     // privateConf: {}, // 私有化部署方案所需的配置
    //                     debugLevel: "debug", //设置日志level
    //                     onconnect: onConnect,
    //                     onmyinfo: onMyInfo,
    //                     onsysmsg: onSysMsg, // 系统通知
    //                     // 监听自定义消息：用户是否正在输入
    //                     oncustomsysmsg: onCustomSysMsg,
    //                     // 正常消息
    //                     onmsg: onMsg,
    //                     // 消息已读
    //                     onMsgReceipts: onMsgReceipts,
    //                     // 会话
    //                     onsessions: onSessions,
    //                     onupdatesession: onUpdateSession,
    //                     // 群组
    //                     onteams: onteams, // 初始化时同步群列表的回调
    //                     onCreateTeam: onCreateTeam, // 创建群后群主收到消息


    //                 });
    //                 Vue.prototype.nim = nim;
    //             }
    //         })
    //         .catch((error) => console.log(error));
    // }
}
// 连接成功
function onConnect() {
    console.log("连接成功");
}
function onMyInfo(user) {
    console.log('收到我的名片', user);
    // data.myInfo = user;
    store.commit('MY_INFO', user)
}
// 系统通知
function onSysMsg(sysMsg) {
    console.log("收到系统通知", sysMsg);
    // 处理对方撤回的消息
    if (sysMsg.type == "deleteMsg") {
        store.commit('UPDATE_CHAT_HISTORY_FILTER', sysMsg.msg.idClient);
        // sendCustomMsg("对方撤回");
    }
}
// 自定义消息：用户是否正在输入
function onCustomSysMsg(sysMsg) {
    console.log("收到自定义系统通知", sysMsg);
    let selectedKeys = getStorage("selectedKeys");
    if (sysMsg.from == selectedKeys) {
        let content = JSON.parse(sysMsg.content);
        store.commit('USER_IS_TYPING', content.content)
    }
}
// 消息
function onMsg(msg) {
    let selectedKeys = getStorage("selectedKeys");
    // 判断这条消息是不是在当前会话下
    console.log(selectedKeys, 'selectedKeys');
    if (msg.target == selectedKeys) {
        nim.resetSessionUnread("team-" + selectedKeys);
    }
    if (msg.type == "file" || msg.type == "image") {
        msg.file = [msg.file];
    }
    if (msg.type == "custom") {
        msg.content = JSON.parse(msg.content);
    }
    msg.msgTime = timestampToTime(msg.time);
    getUsers(msg);
    if (msg.target == selectedKeys) {
        store.commit('UPDATE_CHAT_HISTORY', msg)
    }
    // 会话超时
    if (msg.type == "custom" && msg.subType == '11' && msg.content.custom_type == 'endChat' && msg.content.end_type == 'timeout') {
        // 删除会话
        nim.deleteLocalSession({
            id: `team-${msg.target}`,
            done: function deleteLocalSessionDone(error, obj) {
                console.log("删除会话" + (!error ? "成功" : "失败"), error, obj);
                setTimeout(() => {
                    store.commit('UPDATE_CONVERSATION_LIST', obj.id);
                }, 1000);
            },
        });
    }
    // 重置该会话的定时器
    resetTimer(msg.to);
    store.commit('CHAT_NOTION_MSG', msg)
    console.log("收到消息", msg.scene, msg.type, msg);
}
// 消息已读
function onMsgReceipts(MsgReceipts) {
    let newMessages = store.state.newMessages
    let MsgReceiptsT = MsgReceipts[0].msgReceiptTime
    store.commit('MSG_RECEIPTS', MsgReceiptsT)
    newMessages.map((item) => {
        if (item.idClient) {
            item.isRead = true;
        }
    });
}
// 开始定时器
function startTimer(sessionId) {
    const session = sessionManager.sessions[sessionId];
    if (session.timerId !== null) {
        // clearTimeout(session.timerId); // 如果定时器已经在运行，先取消它
        session.timerId = null; // 重置定时器ID
    }
    session.timerId = setTimeout(() => {
        handleSessionTimeout(sessionId);
    }, sessionManager.timeout);
}
// 重置定时器
function resetTimer(sessionId) {
    const session = sessionManager.sessions[sessionId];
    if (session.timerId !== null) {
        clearTimeout(session.timerId); // 取消当前的定时器
    }
    console.log("重置定时器", sessionId, sessionManager);
    session.lastMessageTime = Date.now(); // 更新最后消息时间
    startTimer(sessionId); // 重新设置定时器
}
// 处理会话超时
function handleSessionTimeout(sessionId) {
    const session = sessionManager.sessions[sessionId];
    if (Date.now() - session.lastMessageTime >= sessionManager.timeout && session.l_id != 0) {
        console.log("会话超时", sessionId, sessionManager);
        let params = {
            microservices: "lmall/admins/im/kf/disconnect",
            tid: sessionId,
            is_timeout: 1,
        };
        PostData(params).then(res => {
            if (res.data.data.state == 200) {
                // 删除会话
                Vue.prototype.nim.deleteLocalSession({
                    id: `team-${sessionId}`,
                    done: function deleteLocalSessionDone(error, obj) {
                        console.log("删除会话" + (!error ? "成功" : "失败"), error, obj);
                        setTimeout(() => {
                            store.commit('UPDATE_CONVERSATION_LIST', obj.id);
                        }, 1000);
                    },
                });
            } else {
                // Vue.prototype.$message.warning(res.data.data.erroer);
            }
        }).catch(error => console.log(error));
    }
}
// 会话
function onSessions(sessions) {
    conversationList = nim.mergeSessions(conversationList, sessions);
    // 获取当前聊天人
    let userId = conversationList[0] && conversationList[0].to;
    let accounts = [];
    let unread = 0;
    conversationList.map((item, index) => {
        accounts.push(item.to);
        unread += Number(item.unread);
        if (item.lastMsg && item.lastMsg.type == 'custom') {
            if (item.lastMsg.content) {
                if (isJSON(item.lastMsg.content)) {
                    console.log('是一个合法的 JSON 字符串');
                    item.lastMsg.content = JSON.parse(item.lastMsg.content)
                } else {
                    console.log('不是一个合法的 JSON 字符串');
                }
            }
        }
    });
    getTeam(accounts);
    // getUsers(accounts);
    setTimeout(() => {
        // 置顶数据
        let isTop = conversationList.filter((item) => item.isTop);
        // 非置顶数据
        let noTop = conversationList.filter((item) => !item.isTop);
        if (noTop.length > 1) {
            noTop.sort((a, b) => {
                return b.updateTime - a.updateTime; // 注意这里是b - a，因为我们想要降序排序
            });
        }
        conversationList = [...isTop, ...noTop];
        // 初始化定时器
        if (conversationList.length) {
            conversationList.forEach((item) => {
                sessionManager.sessions[item.to] = item;
                sessionManager.sessions[item.to] = {
                    lastMessageTime: Date.now(),
                    l_id: item.l_id,
                    timerId: null,
                };
                startTimer(item.to);
            });
        }
    }, 100);
    setTimeout(() => {
        storage.setItem('conversationListCopy', JSON.parse(JSON.stringify(conversationList)));
        store.commit("CHAT_UNREAD", Number(unread));
        store.commit("USER_ID", userId);
        console.log(conversationList, '会话');
        store.commit("CONVERSATION_LIST", conversationList);
    }, 100);
}
// 更新会话
function onUpdateSession(sessions) {
    conversationList = nim.mergeSessions(conversationList, sessions);
    let accounts = [];
    let unread = 0;
    conversationList.map((item) => {
        accounts.push(item.to);
        unread += Number(item.unread);
        if (item.lastMsg && item.lastMsg.type == 'custom') {
            if (item.lastMsg.content) {
                if (isJSON(item.lastMsg.content)) {
                    console.log('是一个合法的 JSON 字符串');
                    item.lastMsg.content = JSON.parse(item.lastMsg.content)
                } else {
                    console.log('不是一个合法的 JSON 字符串');
                }
            }
        }
    });
    getTeam(accounts);
    // getUsers(accounts);
    setTimeout(() => {
        // 获取置顶的数据
        // 置顶数据
        let isTop = conversationList.filter((item) => item.isTop);
        // 非置顶数据
        let noTop = conversationList.filter((item) => !item.isTop);
        if (noTop.length > 1) {
            noTop.sort((a, b) => {
                return b.updateTime - a.updateTime; // 注意这里是b - a，因为我们想要降序排序
            });
        }
        conversationList = [...isTop, ...noTop];
        if (store.state.deleteUserId) {
            conversationList = conversationList.filter((item) => item.id != store.state.deleteUserId);
            store.commit("UPDATE_DELETE_USERID");
        }
        // 初始化定时器
        if (conversationList.length) {
            conversationList.forEach((item) => {
                sessionManager.sessions[item.to] = item;
                sessionManager.sessions[item.to] = {
                    lastMessageTime: Date.now(),
                    l_id: item.l_id,
                    timerId: null,
                };
                startTimer(item.to);
            });
        }
    }, 100);
    setTimeout(() => {
        storage.setItem('conversationListCopy', JSON.parse(JSON.stringify(conversationList)));
        store.commit("CHAT_UNREAD", Number(unread));
        console.log(conversationList, '会话更新');
        store.commit("CONVERSATION_LIST", conversationList);
    }, 100)
}
// 获取群组信息
function getTeam(accounts) {
    // 群组信息
    nim.getTeamsById({
        teamIds: accounts,
        done: getTeamDone
    });
    function getTeamDone(error, obj) {
        console.log('获取群' + (!error ? '成功' : '失败'), obj);
        if (!error) {
            conversationList.map((item) => {
                obj.teams.map((usersItem) => {
                    if (item.to == usersItem.teamId) {
                        let serverCustom = JSON.parse(usersItem.serverCustom);
                        item.nick = serverCustom.u;
                        item.avatar = serverCustom.i;
                        item.l_id = serverCustom.l_id;
                    }
                });
            });
        }
    };
}
// 获取用户资料
function getUsers(msg) {
    nim.getUsers({
        accounts: [msg.from],
        done: function getUsersDone(error, users) {
            console.log("获取用户资料数组" + (!error ? "成功" : "失败"), users);
            if (!error) {
                users.map((usersItem) => {
                    if (msg.from == usersItem.account) {
                        msg.avatar = usersItem.avatar;
                    }
                });
            }
        },
    });
}

// 自定义撤回内容
function sendCustomMsg(type = "撤回") {
    let selectedKeys = getStorage("selectedKeys");
    var content = {
        custom_type: type,
    };
    var msg = Vue.prototype.nim.sendCustomMsg({
        scene: "team",
        to: selectedKeys,
        content: JSON.stringify(content),
        isLocal: true,
        done: (error, obj) => {
            if (obj.type == "custom") {
                obj.content = JSON.parse(obj.content);
            }
            store.commit('UPDATE_CHAT_HISTORY', obj)
            console.log("撤回" + (!error ? "成功" : "失败"), error, obj);
        },
    });
}
/**
 * 初始化后，收到群信息的回调函数
 */
function onteams(teams) {
    console.log("收到群信息", teams);
}
/**
 * 群创建者收到 onCreateTeam 的回调函数(即包括创建发起端，也包括发起者多端同步账户)
 * 
 * 收到群创建消息后，可以调用 getTeamMembers，拉取群组成员
 */
function onCreateTeam(team) {
    console.log("群创建成功", team);
}

function isJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}
// 转换时间戳
function timestampToTime(time) {
    var date = new Date(time);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let m = date.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    // return y + '年' + MM + '-' + d + '日'
    return y + "-" + MM + "-" + d + " " + h + ":" + m;
}
export default initNim;



// WEBPACK FOOTER //
// ./src/config/nim.js